import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { VerificareEvidentaService } from './verificare-evidenta.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';

@Component({
    selector: 'app-verificare-evidenta',
    templateUrl: './verificare-evidenta.component.html',
    styleUrls: ['./verificare-evidenta.component.scss']
})
export class VerificareEvidentaComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    helper = helper;

    isLoading = false;
    showCard = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink = environment.interop.basePath + environment.interop.indoc.verificareEvidenta.getVerificareEvidentaDT;

    constructor(
        private http: HttpClient,
        private verificareEvidentaService: VerificareEvidentaService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Entitate',
                    data: 'id_entitate',
                },
                {
                    title: 'Document intrare',
                    data: 'id_document_intrare',
                },
                {
                    title: 'CNP/CUI',
                    data: 'cnp_cui',
                },
                {
                    title: 'Adresa',
                    data: 'adresa',
                },
                {
                    title: 'Observații',
                    data: 'obs',
                },
                {
                    title: 'Lot procesat',
                    data: 'procesat_lot',
                    render: (data: any) => {
                        if (data == true) {
                            return 'Da';
                        }
                        if (data == false) {
                            return 'Nu';
                        }
                        return '';
                    }
                },
                {
                    title: 'Dată lot procesat',
                    data: 'procesat_lot_date',
                    render: (data: any) => {
                        return this.formatDate(data);
                    }
                },
            ]
        };
    }

    rerenderDT(paginate: boolean = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });

        this.showCard = false;
    }

    formatDate(dateString: string): string {
        if (!dateString) return '';

        const [year, month, day] = dateString.split('-');
        return `${day}.${month}.${year}`;
    }
}
